import React from 'react';
import ActionRow from './actionrow';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';

export default function ActionCustomerItem(props) {

    const isOrderPending = (locationId) => {
        return false;
    };

    const openCustomer = () => {
        props.history.push('/customers/' + props.customer.id);
    };

    let customer = props.customer;

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Grid container direction="row" alignItems="center">
                    <Grid item>
                        <OpenInNewIcon onClick={openCustomer} sx={{ verticalAlign: 'middle', cursor: 'pointer' }} />
                    </Grid>
                    <Grid item>
                        <span style={{ fontSize: '1.4em', fontWeight: '500' }}>
                            {customer.name}({customer.locationCount})
                        </span>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails sx={{ display: 'block' }}>
                {customer.actionList.map((item) => (
                    <ActionRow
                        key={item.id}
                        type="info"
                        action={item}
                        hasPendingOrder={isOrderPending(item.location.id)}
                        newOrderFromLocations={props.newOrderFromLocations}
                        history={props.history}
                    />
                ))}
            </AccordionDetails>
        </Accordion>
    );
}
